import { CountryConfigType } from '../../model/CountryConfigType'

const config: CountryConfigType = {
  showQuoteSummaryAgreementNotice: true,
  showLanguageSelector: true,
}

export default config
